import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { jsonBody, successResponse, tagPaths } from "../util.ts";

extendZodWithOpenApi(z);

//#region Referral
export const ReferralEnabled = z
    .object({
        enabled: z.boolean(),
    })
    .openapi({ ref: "ReferralEnabled" });

export const ReferralAmounts = z
    .object({
        promoter_credit: z.number().describe("Credit granted to the existing user who shared the referral code."),
        receiver_credit: z.number().describe("Credit granted to the newly registered user who used the referral code."),
        receiver_precondition_topup_sum: z
            .number()
            .describe("Minimum top-up amount the referred user must complete before receiver credit is awarded."),
    })
    .openapi({ ref: "ReferralAmounts" });
//#endregion

export const referralPaths = tagPaths("admin_referral")({
    "/payment/admin/referral_enabled": {
        get: {
            summary: "Get referral program status",
            responses: { ...successResponse(ReferralEnabled) },
        },
        put: {
            summary: "Update referral program status",
            requestBody: jsonBody(ReferralEnabled),
            responses: { ...successResponse(ReferralEnabled) },
        },
    },
    "/config/payment/referral_amounts": {
        get: {
            summary: "Get referral program credit amounts",
            responses: { ...successResponse(ReferralAmounts) },
        },
        put: {
            summary: "Update referral program credit amounts",
            requestBody: jsonBody(ReferralAmounts),
            responses: { ...successResponse(ReferralAmounts) },
        },
    },
});
